import { LoadState, LoadStateInitialValue } from 'app/core/interfaces/generic.interface';
import { Definition } from 'app/core/store/definitions/definition.interface';
import * as customerInfoActions from 'app/core/store/customer-info/customer-info.actions';
import * as userContextActions from 'app/core/store/session/user-context/user-context.actions';
import * as actions from './active-customer.actions';

const INITIAL_STATE: LoadState<Definition> = new LoadStateInitialValue<Definition>();

function setActiveCustomer(action: actions.SetActiveCustomerAction, state: LoadState<Definition>): LoadState<Definition> {
  return {
    ...INITIAL_STATE,
    loadSuccess: true,
    data: action.payload,
  };
}

function userContextLoad(action: userContextActions.UserContextLoadAction, state: LoadState<Definition>): LoadState<Definition> {
  return {
    ...INITIAL_STATE,
    loading: true,
  };
}

function userContextLoadSuccess(action: userContextActions.UserContextLoadSuccessAction, state: LoadState<Definition>): LoadState<Definition> {
  return {
    ...INITIAL_STATE,
    loadSuccess: true,
    data: {
      id: action.payload.activeCustomerId,
      name: action.payload.activeCustomerName,
    },
  };
}

function userContextLoadFail(action: userContextActions.UserContextLoadFailAction, state: LoadState<Definition>): LoadState<Definition> {
  return {
    ...INITIAL_STATE,
    loadFailed: true,
    errorMessage: action.payload,
  };
}

function customerInfoLoad(action: customerInfoActions.CustomerInfoLoadAction, state: LoadState<Definition>): LoadState<Definition> {
  return {
    ...INITIAL_STATE,
    loading: true,
  };
}

function customerInfoLoadSuccess(action: customerInfoActions.CustomerInfoLoadSuccessAction, state: LoadState<Definition>): LoadState<Definition> {
  return {
    ...INITIAL_STATE,
    loadSuccess: true,
    data: action.payload.customer,
  };
}

function customerInfoLoadFail(action: customerInfoActions.CustomerInfoLoadFailAction, state: LoadState<Definition>): LoadState<Definition> {
  return {
    ...INITIAL_STATE,
    loadFailed: true,
    errorMessage: action.payload,
  };
}

export function reducer(state = INITIAL_STATE, action: actions.Actions | userContextActions.Actions | customerInfoActions.Actions): LoadState<Definition> {
  let newState = state;

  switch (action.type) {
    case actions.SET_ACTIVE_CUSTOMER:
      newState = setActiveCustomer(action, state);
      break;
    case userContextActions.USERCONTEXT_LOAD:
      newState = userContextLoad(action, state);
      break;
    case userContextActions.USERCONTEXT_LOAD_SUCCESS:
      newState = userContextLoadSuccess(action, state);
      break;
    case userContextActions.USERCONTEXT_LOAD_FAIL:
      newState = userContextLoadFail(action, state);
      break;
    case customerInfoActions.CUSTOMER_INFO_LOAD:
      newState = customerInfoLoad(action, state);
      break;
    case customerInfoActions.CUSTOMER_INFO_LOAD_SUCCESS:
      newState = customerInfoLoadSuccess(action, state);
      break;
    case customerInfoActions.CUSTOMER_INFO_LOAD_FAIL:
      newState = customerInfoLoadFail(action, state);
      break;
  }
  return newState;
}
